// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Zh","container":"e__h","right":"e_0h","image":"e_1h","scoreLine":"e_2h","scoreRing":"e_3h","badge":"e_4h","badgeImage":"e_5h","badgeRing":"e_6h","large":"e_7h"};